import React, { useEffect } from "react";
import { ScrollToTop } from "../components/ScrollToTop";

const EULA = () => {
  useEffect(() => {
    
  }, []);
  return (
    <div className="max-w-4xl mx-auto p-6 text-gray-800">
      <head>
        <title>End-User License Agreement</title>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta name="theme-color" content="#000000" />
        <meta
          name="description"
          content="Exclusive collection of silver jewellery at jaw dropping prices."
        />
        <link rel="icon" href="favicon1.ico" />
      </head>
      <h1 className="text-3xl font-bold mb-4">End-User License Agreement</h1>
      <p className="mb-4">Updated at 2023-06-20</p>
      <p className="mb-4">
        Sairah A venture of Soradis Group under Soradis Jewellers Private
        Limited hereby grants you access to{" "}
        <a
          href="https://sairahjewels.com/"
          className="text-blue-500 hover:underline"
          target="_blank"
          rel="noopener noreferrer"
        >
          https://sairahjewels.com/
        </a>{" "}
        (“the Website”) and invites you to purchase the services offered here.
      </p>

      <Section title="Definitions and key terms">
        <ul className="list-disc pl-6 space-y-2">
          <li>
            <strong>Cookie:</strong> small amount of data generated by a website
            and saved by your web browser.
          </li>
          <li>
            <strong>Company:</strong> Soradis Jewellers Private Limited, 2029,
            NIBR Corporate Park 1Aerocity, Andheri(E), Mumbai.
          </li>
          <li>
            <strong>Country:</strong> India
          </li>
          <li>
            <strong>Service:</strong> Services provided as described on this
            platform.
          </li>
          <li>
            <strong>Third-party service:</strong> Partners and advertisers.
          </li>
          <li>
            <strong>Website:</strong>{" "}
            <a
              href="https://sairahjewels.com/"
              className="text-blue-500 hover:underline"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://sairahjewels.com/
            </a>
          </li>
          <li>
            <strong>You:</strong> A person or entity registered to use the
            services.
          </li>
        </ul>
      </Section>

      <Section title="Introduction">
        <p className="mb-4">
          This End User License Agreement (the “Agreement”) is a binding
          agreement between you (“End User”) and Soradis Jewellers Private
          Limited (“Company”). This Agreement governs your use of Sairah A
          venture of Soradis Group under Soradis Jewellers Private Limited.
        </p>
        <p className="mb-4">
          If you use the website on behalf of an organisation, you warrant that
          you have the authority to bind the organisation to the terms.
        </p>
        <p className="mb-4">
          By using the website, you accept and agree to be legally bound by this
          Agreement. If you do not agree, do not use the software.
        </p>
      </Section>

      <Section title="License">
        <ul className="list-disc pl-6 space-y-2">
          <li>
            Download, install and use on one device per license purchased.
          </li>
          <li>Use provided materials strictly under this Agreement.</li>
          <li>Trial use for 15 days on any device.</li>
          <li>Receive updates for one year from purchase date.</li>
        </ul>
      </Section>

      <Section title="Restrictions">
        <ul className="list-disc pl-6 space-y-2">
          <li>Do not sublicense, rent, or distribute the application.</li>
          <li>No reverse engineering or derivative works.</li>
          <li>Do not remove proprietary notices.</li>
        </ul>
      </Section>

      <Section title="Intellectual Property">
        <p className="mb-4">
          All rights to the software remain with Soradis Jewellers Private
          Limited. This agreement only grants a limited license.
        </p>
      </Section>

      <Section title="Your Suggestions">
        <p className="mb-4">
          Suggestions provided to the company will be the sole property of the
          company without compensation to you.
        </p>
      </Section>

      <Section title="Modifications and Updates">
        <p className="mb-4">
          The company may modify or update the application at any time without
          notice.
        </p>
      </Section>

      <Section title="Term and Termination">
        <p className="mb-4">
          This Agreement remains in effect until terminated by either party.
        </p>
        <p className="mb-4">
          Upon termination, you must stop using and delete the application.
        </p>
      </Section>

      <Section title="Indemnification">
        <p className="mb-4">
          You agree to indemnify and hold the company harmless from claims
          arising from your use, legal violations, or contract breaches.
        </p>
      </Section>

      <Section title="No Warranties & Limitation of Liability">
        <p className="mb-4">
          The software is provided "as is" without warranty. Liability is
          limited to the amount paid.
        </p>
      </Section>

      <Section title="General Provisions">
        <ul className="list-disc pl-6 space-y-2">
          <li>Governing Law: Indian Law</li>
          <li>Severability: Invalid terms will not affect the rest</li>
          <li>No waiver without written notice</li>
          <li>We may amend the agreement with 30 days' notice</li>
        </ul>
      </Section>
    </div>
  );
};

const Section = ({ title, children }) => (
  <section className="mb-8">
    <h2 className="text-2xl font-semibold mb-2">{title}</h2>
    {children}
  </section>
);

export default EULA;
